var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSend = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  className: "send_svg__svg-safari-fix",
  viewBox: "0 0 16 16",
  "aria-hidden": props["aria-label"] || props["aria-labelledby"] ? undefined : true
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M3.267 2.594 14 6.687v.007c.5.22.807.68.807 1.213 0 .534-.307.994-.807 1.214L3.24 13.227a1.3 1.3 0 0 1-.527.107c-.333 0-.666-.12-.926-.347a1.29 1.29 0 0 1-.4-1.347l.026-.073 1.567-3.7-1.593-3.693A1.3 1.3 0 0 1 1.78 2.82a1.41 1.41 0 0 1 1.487-.227m-.587 9.393c.007.007.053 0 .053 0L13.44 7.894 2.767 3.82c-.04-.014-.08-.014-.08-.014l1.473 3.42h2.547c.366 0 .666.3.666.667s-.3.667-.666.667H4.133z",
  clipRule: "evenodd"
})));
export default SvgSend;